import {
  POST_PENDIENTE_LOADING,
  POST_PENDIENTE_SUCCESS,
  POST_PENDIENTE_ERROR,
} from "../../../constants/ActionTypes";
import axiosInstance from "../../../helpers/axiosInstance";

const postPendientes = (base64Files) => (dispatch) => {
  dispatch({
    type: POST_PENDIENTE_LOADING,
  });
  let postBody = { Binarios: [] };
  base64Files.forEach((base64) => {
    postBody.Binarios.push({ base64 });
  });

  axiosInstance()
    .post("/Media/grupo", postBody)
    .then((res) => {
      dispatch({
        type: POST_PENDIENTE_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: POST_PENDIENTE_ERROR,
        payload: err,
      });
    });
};

export default postPendientes;
